import { useTranslation } from 'react-i18next'

import { BAZAAR_URL, bazaarShown } from '../../lib/download'

/**
 * «دریافت از کافه‌بازار»: a link to the app's Café Bazaar page, drawn on the
 * Persian site only (nothing at all in English). A plain labelled button — no
 * explanatory sentence — that opens the store in a new tab. [className] is
 * the surface's own button look, so it sits beside the APK button the way
 * that surface draws buttons.
 */
export default function BazaarButton({ className }) {
  const { t, i18n } = useTranslation('download')
  if (!bazaarShown(i18n.resolvedLanguage ?? i18n.language)) return null
  return (
    <a href={BAZAAR_URL} target="_blank" rel="noopener" className={className}>
      {t('bazaar')}
    </a>
  )
}
